export const CHAT = {
  chat: {
    createNewChat: 'New chat',
    newChat: 'New chat',
    searchPlaceholder: 'Search',
    recentChats: 'Recent Chats',
    welcomeMessage: 'How can I help you today?',
    welcomeCaveat:
      'You are using an Artificial Intelligence (AI) equipped tool. Users are not communicating with a live safety professional, rather are communicating with an AI chatbot. The AI generated responses provided by Enstructure’s Safety Virtual Assistant are intended only for informational use. The information provided by the Enstructure Safety Virtual Assistant is not intended as, nor does it constitute, specific technical or legal advice to the user. AI tools, GPT’s or chatbots occasionally provide incorrect information. It is the user’s responsibility to validate the information provided and to use reasonable care when using the information provided. When in doubt, consult a member of Enstructure’s Safety Team for assistance.',
    loadingChats: 'Loading chats...',
    loadingMessages: 'Loading conversation...',
    promptPlaceholder: 'Ask anything...',
    deleteChat: 'Delete chat',
    disclaimer: 'AI can make mistakes. Always verify important information.',
    agentName: 'Safety Enstructure',
    thinking: 'Thinking',
    sources: 'Sources',
    pageAbbrev: 'p.',
    anonymousUser: 'Anonymous User',
    imminentDanger: {
      question: "Is this a situation where someone's life is in imminent danger?",
      yes: 'Yes',
      no: 'No',
      emergencyMessage:
        'Stop work and immediately contact your supervisor, your terminal safety team or the Chief Safety Officer Jim Bailey at 804-640-6816.',
      continue: 'I am safe — continue to assistant',
    },
    anonChatDisabled: 'Anonymous chat is temporarily unavailable. Please sign in to continue.',
    errors: {
      title: 'Something went wrong',
      loadChats: 'Failed to load chats.',
      loadMessages: 'Failed to load messages.',
      createChat: 'Failed to create chat.',
      deleteChat: 'Failed to delete chat.',
      sendMessage: 'Failed to send message.',
      dismiss: 'Dismiss',
    },
  },
}
